import { Icons } from '@Assets/SvgIcons';
import { RouteEnums } from '@Helper/Enums';
import { ComponentHelper, useEffectAsync } from '@Helper/Infra';
import { DealProjectDTO, SubscriptionType } from '@Helper/Interfaces';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import { Button, Dialog } from '@mui/material';
import { getUserDealspaceList } from '@Store/feature/dealspaceSlice';
import { getIsUserIMO, getUserInfo } from '@Store/feature/directory';
import { getPlayBookDetail } from '@Store/feature/playBookDetailSlice';
import {
  getPurePlaybookList,
  postPurePlaybookList,
} from '@Store/feature/purePlaybookSlice';
import { useAppDispatch, useAppSelector } from '@Store/hooks';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import classes from './../../../components/UI/TodoCard/TodoCard.module.css';

type WsFreeProps = {
  playbookId?: string;
};

type WsModalProps = {
  open: boolean;
  handleClose: (close: boolean) => void;
  payWs: () => void;
  playbookId: string;
};

export default function TrialEndBanner() {
  let navigate = useNavigate();
  const { id } = useParams();
  const isUserImo = useAppSelector(getIsUserIMO);
  const userDealspaceList = useAppSelector(getUserDealspaceList) ?? [];
  const goPaymentAccount = () => {
    navigate(RouteEnums.WorkstreamPlan, { state: { dealspaceId: id } });
  };

  return (
    <div
      style={{
        background: '#FFBDAD',
        display: 'flex',
        color: '#1C174D',
        fontSize: 13,
        height: 40,
        padding: '8px 16px',
        alignItems: 'center',
      }}
    >
      <Icons.Info />
      <div
        style={{
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          justifyItems: 'center',
          marginLeft: 15,
        }}
      >
        Trial expired:
      </div>
      <div
        style={{
          marginLeft: 15,
        }}
      >
        Your workstream is currently read-only. Please select a plan to
        continue.
      </div>
      <div
        style={{
          color: '#46426E',
          background: '#ffffff',
          fontWeight: 600,
          height: 25,
          display: 'flex',
          alignItems: 'center',
          justifyItems: 'center',
          padding: '13px 5px',
          cursor: 'pointer',
          marginLeft: 15,
          border: '1px solid #B5B3C5',
          borderRadius: 4,
        }}
        onClick={() => {
          if (
            isUserImo &&
            userDealspaceList.find(
              i =>
                i.dealspaceOwner === (localStorage.getItem('useremail') ?? '')
            )
          ) {
            goPaymentAccount();
          } else {
            toast('Please contact with your dealspace owner');
          }
        }}
      >
        Select Plan{' '}
      </div>
    </div>
  );
}

export function FreeEndBanner({ playbookId }: WsFreeProps) {
  let navigate = useNavigate();
  const { id, pid } = useParams();
  const [wsModalOpen, setWsModalOpen] = useState(false);
  const userInfo = useAppSelector(getUserInfo);
  const userDealspaceList = useAppSelector(getUserDealspaceList) ?? [];
  const componentHelper = new ComponentHelper();
  const dispatch = useAppDispatch();

  const goPaymentAccount = () => {
    if (
      userDealspaceList.find(
        i => i.dealspaceOwner === (localStorage.getItem('useremail') ?? '')
      )
    ) {
      if (playbookId) {
        setWsModalOpen(true);
        return;
      }
      navigate(RouteEnums.WorkstreamPlan, { state: { dealspaceId: id } });
    } else {
      toast('Only dealspace owner can make subscription');
    }
  };
  return (
    <>
      <div
        style={{
          background: '#FFE380',
          display: 'flex',
          color: '#1C174D',
          fontSize: 13,
          height: 40,
          padding: '8px 16px',
          alignItems: 'center',
        }}
      >
        <Icons.Info />
        <div
          style={{
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyItems: 'center',
            marginLeft: 15,
          }}
        >
          Inactive workstream:
        </div>
        <div
          style={{
            marginLeft: 15,
          }}
        >
          {userDealspaceList.find(i => i.id === id)?.subscriptionType ===
          SubscriptionType.FREE
            ? 'You are currently on a free plan. Please upgrade to start collaborating.'
            : 'This workstream is not included in your subscription. Please activate to start using it again.'}
        </div>
        <div
          style={{
            color: '#46426E',
            background: '#ffffff',
            fontWeight: 600,
            height: 25,
            display: 'flex',
            alignItems: 'center',
            justifyItems: 'center',
            padding: '13px 5px',
            cursor: 'pointer',
            marginLeft: 15,
            border: '1px solid #B5B3C5',
            borderRadius: 4,
          }}
          onClick={() => goPaymentAccount()}
        >
          {userDealspaceList.find(i => i.id === id)?.subscriptionType ===
          SubscriptionType.FREE
            ? 'UPGRADE'
            : 'ACTIVATE WORKSTREAM'}
        </div>
      </div>
      <FreeEndWsBanner
        open={wsModalOpen}
        payWs={async () => {
          if (pid) {
            await componentHelper.addToSubscription(pid);
            const playbooks = (await componentHelper.listPlaybooks(
              id ?? ''
            )) as DealProjectDTO[];
            dispatch(postPurePlaybookList(playbooks));
          }
        }}
        handleClose={() => {
          setWsModalOpen(false);
        }}
        playbookId={playbookId ?? ''}
      />
    </>
  );
}

interface aiUserPrice {
  aiUserCount: number;
  aiUnitPrice: number;
  currency: string;
}

export function FreeEndWsBanner({
  payWs,
  handleClose,
  open,
  playbookId,
}: WsModalProps) {
  const purePlaybookList = useAppSelector(getPurePlaybookList);
  const dealProjectDto = purePlaybookList?.find(i => i.id === playbookId);
  const on = true;
  const { id, pid } = useParams();
  const { userList } = useAppSelector(getPlayBookDetail);
  const [aiEnabled, setAiEnabled] = useState(false);
  const [aiUserSetting, setAiUserSetting] = useState<aiUserPrice | undefined>(
    undefined
  );

  const componentHelper = new ComponentHelper();
  const [priceTag, setpriceTag] = useState('');
  const [paidSuccess, setpaidSuccess] = useState(false);
  useEffectAsync(async () => {
    if (dealProjectDto) {
      console.log('here', dealProjectDto);

      const priceElement = await componentHelper.workstreamPrice(
        dealProjectDto?.project.workspaceId ?? ''
      );
      setpriceTag(priceElement.unitPrice);
    }
  }, [dealProjectDto]);

  useEffectAsync(async () => {
    const aiUserCountResponse = await componentHelper.aiUserCount(id ?? '');
    const aiFeaturePriceDto = await componentHelper.aiFeaturePrice(id ?? '');
    setAiUserSetting({
      aiUnitPrice: aiFeaturePriceDto.data.unitPrice,
      aiUserCount: aiUserCountResponse.data.aiUserCount,
      currency: aiFeaturePriceDto.data.currency,
    });
  }, []);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="add-user-dialog"
      >
        <div className="dialog-header">
          <div className={classes.infoModalHeader}>Workstream Activation</div>
          <button
            className="dialog-close-button"
            onClick={() => handleClose(false)}
          >
            <Icons.Cancel width="22" height="22" color="#000000" />
          </button>
        </div>

        <div className="dialog-content">
          <div className={classes.infoTextDelete}>
            Your workstream will be activated. This will be added in your
            billing cycle.
          </div>

          <div style={{ paddingTop: 20, width: '100%' }}>
            <div className="workstream-item jc-sb">
              <div className="ds-flx al-cnt">
                <div className="workstream-wrapper mb-0">
                  <div
                    className="ws-avatar"
                    style={{ backgroundColor: '#6AAEBD' }}
                  >
                    {dealProjectDto?.project.name[0]}
                  </div>
                  <div className="ws-content">
                    <div className="ws-title ellipsis">
                      {dealProjectDto?.project.name}
                    </div>
                    <div className="ws-desc ellipsis">
                      Owner:{' '}
                      {[
                        userList.find(
                          i =>
                            i.playbookId === dealProjectDto?.id &&
                            i.userRole === 'owner'
                        )?.name,
                        userList.find(
                          i =>
                            i.playbookId === dealProjectDto?.id &&
                            i.userRole === 'owner'
                        )?.surname,
                      ].join(' ')}
                    </div>
                  </div>
                </div>
              </div>
              <div className="ws-toggle" onClick={() => {}}>
                {on ? (
                  <ToggleOnOutlinedIcon
                    sx={{
                      color: '#5D54C0',
                      fontSize: 35,
                      cursor: 'pointer',
                    }}
                  />
                ) : (
                  <ToggleOffOutlinedIcon
                    sx={{
                      color: '#7D7A9A',
                      fontSize: 35,
                      cursor: 'pointer',
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="list-item w-list">
            <div>Enable AI</div>
            <div
              className="ws-toggle"
              onClick={() => {
                setAiEnabled(!aiEnabled);
              }}
            >
              {false ? (
                <></>
              ) : (
                <>
                  {aiEnabled ? (
                    <ToggleOnOutlinedIcon
                      sx={{
                        color: '#5D54C0',
                        fontSize: 35,
                        cursor: 'pointer',
                      }}
                    />
                  ) : (
                    <ToggleOffOutlinedIcon
                      sx={{
                        color: '#7D7A9A',
                        fontSize: 35,
                        cursor: 'pointer',
                      }}
                    />
                  )}
                </>
              )}
            </div>
          </div>
          <div
            style={{
              paddingTop: 20,
              display: 'flex',
              width: '98%',
              flexDirection: 'column',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className={classes.priceTag}>Total active workstream</div>
              <div className={classes.priceTag} style={{ fontWeight: 600 }}>
                {purePlaybookList
                  ?.filter(i => !i.project.isDeleted && !i.project.isFree)
                  .length.toString()}
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className={classes.priceTag}>Current billable:</div>
              <div className={classes.priceTag} style={{ fontWeight: 600 }}>
                ${priceTag}*
                {purePlaybookList
                  ?.filter(i => !i.project.isDeleted && !i.project.isFree)
                  .length.toString()}
                =$
                {(
                  Number(priceTag) *
                  purePlaybookList!?.filter(
                    i => !i.project.isDeleted && !i.project.isFree
                  ).length
                ).toString()}
              </div>
            </div>
            {aiEnabled && (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className={classes.priceTag}>Ai Enabled</div>
                <div className={classes.priceTag} style={{ fontWeight: 600 }}>
                  ${aiUserSetting?.aiUnitPrice}*{aiUserSetting?.aiUserCount}
                  =$
                  {(aiUserSetting?.aiUnitPrice ?? 1) *
                    (aiUserSetting?.aiUserCount ?? 1)}
                </div>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className={classes.priceTag}>Updated bill:</div>
              <div className={classes.priceTag} style={{ fontWeight: 600 }}>
                ${priceTag}*
                {(
                  purePlaybookList!?.filter(
                    i => !i.project.isDeleted && !i.project.isFree
                  ).length + 1
                ).toString()}
                {aiEnabled
                  ? ' + $' +
                    aiUserSetting?.aiUnitPrice +
                    '*' +
                    aiUserSetting?.aiUserCount
                  : ''}
                =$
                {(
                  Number(priceTag) *
                    (purePlaybookList!?.filter(
                      i => !i.project.isDeleted && !i.project.isFree
                    ).length +
                      1) +
                  (aiEnabled
                    ? (aiUserSetting?.aiUnitPrice ?? 1) *
                      (aiUserSetting?.aiUserCount ?? 1)
                    : 0)
                ).toString()}
              </div>
            </div>
          </div>
          <div style={{ marginTop: 20 }}></div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className={classes.infoTextDelete}></div>
            <div>
              <Button
                className={classes.CancelButton}
                onClick={() => handleClose(false)}
              >
                Don’t Activate
              </Button>
              <Button
                className={classes.ConfirmButton}
                onClick={() => {
                  payWs();
                  handleClose(false);
                  setpaidSuccess(true);
                }}
              >
                Confirm Activation
              </Button>
            </div>
          </div>
        </div>
        <div></div>
      </Dialog>
      <FreeEndWsPaid
        handleClose={() => {
          setpaidSuccess(false);
        }}
        open={paidSuccess}
        name={dealProjectDto?.project.name}
      />
    </>
  );
}

export function FreeEndWsPaid({ handleClose, open, name }: any) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="add-user-dialog"
    >
      <div className="dialog-header">
        <div className={classes.infoModalHeader}>Activation Successful</div>
      </div>

      <div className="dialog-content">
        <div className={classes.infoTextDelete}>
          {name} is now activated. You can start inviting your teammates and
          start using the Pro features.
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <Button
              className={classes.CancelButton}
              onClick={() => handleClose(false)}
            >
              Understood
            </Button>
          </div>
        </div>
      </div>
      <div></div>
    </Dialog>
  );
}
